// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2fMgY","description":"PatientConsentPreview_description__2vZ_L"};